import React from 'react'

const ArchiveIcon = ({ color = '#D1D2D3', width = 24, height = 24 }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none">
      <path
        d="M3 5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V7C21 7.74028 20.5978 8.38663 20 8.73244V19C20 20.1046 19.1046 21 18 21H6C4.89543 21 4 20.1046 4 19V8.73244C3.4022 8.38663 3 7.74028 3 7V5ZM6 9V19H18V9H6ZM19 7H5V5H19V7ZM9 12C9 11.4477 9.44772 11 10 11H14C14.5523 11 15 11.4477 15 12C15 12.5523 14.5523 13 14 13H10C9.44772 13 9 12.5523 9 12Z"
        fill={color}
      />
    </svg>
  )
}

export default ArchiveIcon
